/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Time_HintInputs */

const en_site_time_hint = /** @type {(inputs: Site_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usually 1–4 minutes.`)
};

const id_site_time_hint = /** @type {(inputs: Site_Time_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biasanya 1–4 menit.`)
};

/**
* | output |
* | --- |
* | "Usually 1–4 minutes." |
*
* @param {Site_Time_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_time_hint = /** @type {((inputs?: Site_Time_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Time_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_time_hint(inputs)
	return en_site_time_hint(inputs)
});